var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.84h5.49v1.33H4zM4 5.82h9.18v1.33H4zM10.82 20v-5h1.34v1.84H20v1.34h-7.84V20h-1.34zM8.16 14.49v-1.82H4v-1.34h4.16V9.47h1.33v5.02H8.16zM10.82 11.33H20v1.33h-9.18zM14.51 9V4h1.33v1.82H20v1.34h-4.16V9h-1.33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/Filters.bb0754c29e6a9c974d8b2d23c72c1eb1.svg";
export { ForwardRef as ReactComponent };